<template>
  <div class="wrapper">
    <div class="searchBar">
      <el-form
        :model="searchCondition"
        inline
        ref="searchForm"
        label-width="120px"
      >
        <el-form-item label="姓名/手机/邮箱" prop="userInfo">
          <el-input
            v-model="searchCondition.userInfo"
            placeholder="请输入关键字"
            size="small"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="searchCondition.roleId" size="small">
            <el-option value="" label="不限角色"></el-option>
            <el-option
              v-for="role in roleList"
              :value="role.id"
              :label="role.roleName"
              :key="'role' + role.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
          <el-button
            @click="
              Object.assign(searchCondition, $options.data().searchCondition)
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <div class="actBar">
        <div class="leftSide">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="newStaff"
            >新增员工</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-plus" size="mini"
            >导入</el-button
          >
          <el-button type="primary" icon="el-icon-plus" size="mini"
            >导出</el-button
          > -->
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="tableAct('group')"
            >修改部门</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="tableAct('role')"
            >修改角色</el-button
          >
          <!-- <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="tableAct('stop')"
            >停用员工</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="tableAct('freeze')"
            >冻结员工</el-button
          > -->
        </div>
        <div class="rightSide">
          <!-- <el-button>手动排序</el-button>
          <el-button>按字母排序</el-button> -->
        </div>
      </div>
      <el-table
        :data="dataList"
        border
        style="width: calc(100% - 40px); margin: 20px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="roleName" label="头像" min-width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.avatar"
              style="width: 50 px; height: 40px"
              :src="scope.row.avatar"
              fit="contain"
            ></el-image>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="姓名" min-width="200">
        </el-table-column>
        <el-table-column prop="sex" label="性别" width="200">
          <template slot-scope="scope">
            {{ ["保密", "男", "女"][scope.row.sex] }}
          </template>
        </el-table-column>
        <el-table-column prop="groupName" label="部门" width="200">
        </el-table-column
        ><el-table-column prop="roleName" label="角色" width="200">
        </el-table-column
        ><el-table-column prop="mobile" label="手机" width="200">
        </el-table-column
        ><el-table-column prop="accountStatus" label="账号状态" width="200">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editStaff(scope.row)"
              >编辑用户</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="$router.push({ name: 'userDetail', query: scope.row })"
              >用户详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="staffAct('reset', scope.row)"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="getData"
        :current-page.sync="searchCondition.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="searchCondition.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchCondition.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="用户编辑"
      :visible.sync="staffData.ifShow"
      append-to-body
      top="2vh"
      width="50%"
    >
      <staff-edit :staffData="staffData" @eventUp="staffEvent"></staff-edit
    ></el-dialog>
    <el-dialog
      :title="actData.title"
      :visible.sync="actData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form
        :model="actData"
        class="demo-form-inline"
        label-width="120px"
        ref="tableRef"
      >
        <el-form-item
          label="已选员工"
          prop="userList"
          v-if="!(actData.userList.length == 1 && actData.userList[0].id == 0)"
        >
          <div class="chosenBox">
            <div
              class="chosenCell"
              v-for="(user, userIdx) in actData.userList"
              :key="'user' + user.id"
            >
              <div class="detail">
                <el-image
                  style="width: 40px; height: 40px"
                  :src="user.avatar"
                  fit="contain"
                ></el-image>
                <div class="name">{{ user.userName }}</div>
                <div class="job">{{ user.group }}</div>
              </div>
              <i
                class="el-icon-close"
                @click="
                  if (actData.userList.length == 1) {
                    actData.ifShow = false;
                  } else {
                    actData.userList.splice(userIdx, 1);
                  }
                "
              ></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="修改角色"
          prop="roleId"
          v-if="actData.type == 'role'"
        >
          <el-select v-model="actData.roleId" size="small">
            <el-option :value="0" label="请选择角色" disabled></el-option>
            <el-option
              v-for="role in roleList"
              :value="role.id"
              :label="role.roleName"
              :key="'role' + role.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="修改部门"
          prop="groupId"
          v-if="actData.type == 'group'"
        >
          <el-button @click="actData.groupChosen.ifShow = true"
            >{{ actData.groupName || "请选择部门" }}
          </el-button>
        </el-form-item>
        <el-form-item label="原因备注" prop="remark">
          <el-input
            size="small"
            type="textarea"
            maxlength="150"
            v-model="actData.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-dialog
        width="40%"
        title="选择部门"
        :visible.sync="actData.groupChosen.ifShow"
        append-to-body
      >
        双击确认选择部门
        <el-tree
          :data="departmentGroupTree"
          :props="{ label: 'groupName' }"
          @node-click="actTreeClick"
        ></el-tree>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button @click="actData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="actDialogSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchCooperative,
  getRoleListNew,
  getSystemUserList,
  usersBindRole,
  editUsersGroup,
  searchDepartmentGroup,
} from "@/api/index";
import { resetPassword } from "@/api/bus";
import staffEdit from "./staffEdit.vue";
export default {
  data() {
    return {
      departmentGroupTree: [],
      propsSet: {
        children: "children",
        label: "groupName",
      },
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        companyName: "",
        userInfo: "",
        roleId: "",
        departmentId: 0,
      },
      staffData: {
        ifShow: false,
        userName: "",
        account: "",
        sourcePassword: "",
        groupId: "",
        groupName: "",
        roleId: "",
        sex: 0,
        birthdayDate: null,
        emailAddress: "",
        mobile: "",
        weChatAccount: "",
        landline: "",
        jobNumber: "",
        hometown: "",
        graduatedSchool: "",
        graduatedDate: null,
        education: "",
        major: "",
        remark: "",
        id: 0,
      },
      dataList: [],
      roleList: [],
      userChosen: [],
      actData: {
        ifShow: false,
        title: "",
        remark: "",
        userList: [],
        roleId: 0,
        groupId: 0,
        groupName: "",
        groupChosen: { item: {}, count: 0, timeOut: {}, ifShow: false },
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
    this.pageInit();
  },
  methods: {
    actTreeClick(item) {
      if (this.actData.groupChosen.item.id == item.id) {
        this.actData.groupChosen.count++;
      } else {
        this.actData.groupChosen.item = item;
        this.actData.groupChosen.count = 1;
      }
      clearTimeout(this.actData.groupChosen.timeOut);
      this.actData.groupChosen.timeOut = setTimeout(() => {
        if (this.actData.groupChosen.count >= 2) {
          this.actData.groupId = this.actData.groupChosen.item.id;
          this.actData.groupName = this.actData.groupChosen.item.groupName;
          if (this.staffData.ifShow) {
            this.staffData.groupId = this.actData.groupChosen.item.id;
            this.staffData.groupName = this.actData.groupChosen.item.groupName;
          }

          this.$set(this.actData.groupChosen, "ifShow", false);
        }
        this.actData.groupChosen.count = 0;
      }, 300);
    },
    actDialogSubmit() {
      switch (this.actData.type) {
        case "role":
          usersBindRole({
            roleId: this.actData.roleId,
            userIds: this.actData.userList.map((item) => item.id),
            remark: this.actData.remark,
          }).then((data) => {
            console.log(data);
            this.$message.success(data.info);
            this.actData.ifShow = false;
            this.getData();
          });
          break;
        case "group":
          if (this.staffData.ifShow) {
            //     // this.staffData.groupId = this.actData.groupId;
            //     // this.staffData.groupName = this.actData.groupName;
            //     this.$set(this.staffData, "groupId", this.actData.groupId);
            //     this.$set(this.staffData, "groupName", this.actData.groupName);
            //     this.actData.ifShow = false;
            this.actData.ifShow = false;
          } else {
            // let postData = {};
            // Object.assign(postData, this.actData);
            // postData.groupId = this.actData.groupId;
            // postData.groupName = this.actData.groupName;
            editUsersGroup({
              userIds: this.actData.userList.map((item) => item.id),
              departmentGroupId: this.actData.groupId,
            }).then((data) => {
              this.$message.success(data.info);
              this.actData.ifShow = false;
              this.getData();
            });
          }

          break;
        default:
          break;
      }
    },
    staffAct(type, item) {
      let tipsMap = { reset: "重置密码", stop: "停用", freeze: "冻结" };
      this.$confirm(`确认 ${tipsMap[type]} 吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((data) => {
        switch (type) {
          case "reset":
            resetPassword({ userId: item.id, password: "12345678" }).then(
              (data) => {
                this.$message.success(data.info);
                this.actData.ifShow = false;
                this.getData();
              }
            );
            break;

          default:
            break;
        }
      });
    },
    tableAct(type, item) {
      this.actData.userList = this.userChosen;
      switch (type) {
        case "role":
          Object.assign(this.actData, {
            ifShow: true,
            title: "修改角色",
            type: type,
            item: item,
          });
          break;
        case "group":
          Object.assign(this.actData, {
            ifShow: true,
            title: "修改部门",
            type: type,
            item: item,
            groupName: "",
            groupId: 0,
          });
        default:
          break;
      }
    },
    staffEvent(options) {
      console.log(options);
      switch (options.type) {
        case "success":
          this.$message.success(options.value);
          this.getData();
          this.staffData.ifShow = false;
          break;
        case "group":
          this.actData.userList = [options.value];
          Object.assign(this.actData, {
            ifShow: true,
            title: "修改部门",
            type: options.type,
            item: options.value,
            groupName: options.value.groupName,
            groupId: options.value.groupId,
          });
        default:
          break;
      }
    },
    pageInit() {
      getRoleListNew().then((data) => {
        this.roleList = data.rows;
      });
      searchDepartmentGroup().then((data) => {
        this.departmentGroupTree = data;
      });
    },
    getData() {
      getSystemUserList(this.searchCondition).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
      });
    },
    editStaff(item) {
      Object.assign(this.staffData, item);
      this.staffData.ifShow = true;
    },
    newStaff() {
      Object.assign(this.staffData, this.$options.data().staffData);
      this.staffData.ifShow = true;
    },

    deleteUser(item) {},
    handleSelectionChange(data) {
      this.userChosen = Array.from(data);
    },
  },
  components: { staffEdit },
};
</script>

<style scoped lang="less">
.wrapper {
  //   display: flex;
  min-height: 600px;
  .searchBar {
    background: #fff;
    padding-top: 20px;
    margin-bottom: 20px;
  }

  .structureSide {
    flex: 1;
    min-width: 200px;
    margin-right: 10px;
    background: #fff;
  }
  .detailSide {
    flex: 5;
    background: #fff;
    padding: 20px;
  }
  .tableBox {
    background: #fff;
    .actBar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
    }
  }
}
.chosenBox {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .chosenCell {
    padding: 0 10px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:last-child {
      border: none;
    }
    .detail {
      display: flex;
      height: 50px;
      align-items: center;
      .name {
        color: #999;
        margin-left: 10px;
      }
      .job {
        color: #ccc;
      }
    }
  }
}
</style>
